(() => {
  'use strict';

  const rootOf = (element) => element?.closest('product-info.rf-floorboards-v4');
  const cardsOf = (root) => [...root.querySelectorAll('[data-rf-v4-card]')];
  const enquiryOf = (root) => [...root.querySelectorAll('[data-rf-v4-enquire-colour]')];
  const purchaseOf = (root) => [...root.querySelectorAll('[data-rf-v4-purchase-colour]')];
  const formColoursOf = (root) => [...root.querySelectorAll('[data-rf-enquiry-colour-choice]')];
  const findCard = (root, name) => cardsOf(root).find((card) => card.dataset.colour === name);

  function summary(root) {
    const selected = enquiryOf(root).filter((el) => el.checked).map((el) => el.value);
    const purchase = purchaseOf(root).find((el) => el.checked);
    const label = root.querySelector('[data-rf-v4-selection-summary]');
    if (label) {
      label.textContent = root.dataset.rfV4Mode === 'enquiry'
        ? (selected.length ? selected.length + ' colour' + (selected.length === 1 ? '' : 's') + ' selected for your quote.' : 'Choose colours for your quote, or continue without selecting.')
        : (purchase ? 'Selected colour: ' + purchase.value : 'Choose one colour.');
    }
  }

  function syncEnquiryForm(root) {
    const selected = new Set(enquiryOf(root).filter((el) => el.checked).map((el) => el.value));
    formColoursOf(root).forEach((el) => {
      const checked = selected.has(el.value);
      if (el.checked !== checked) {
        el.checked = checked;
        el.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    const hidden = root.querySelector('[data-rf-enquiry-colour]');
    if (hidden) hidden.value = [...selected].join(', ');
    summary(root);
  }

  function preview(root, name, url) {
    cardsOf(root).forEach((card) => {
      const active = !!name && card.dataset.colour === name;
      card.classList.toggle('is-previewed', active);
      card.querySelector('[data-rf-v4-preview]')?.setAttribute('aria-pressed', String(active));
    });
    const hero = root.querySelector('rf-colour-viewer[data-rf-v2-part="viewer"] [data-rf-v2-viewer-image]');
    if (hero && url) {
      hero.src = url;
      hero.removeAttribute('srcset');
      hero.alt = name || hero.alt;
    }
  }

  function selectVariant(root, name) {
    const grid = root.querySelector('[data-rf-v4-grid]');
    const picker = root.querySelector('variant-selects');
    if (!grid || !picker) return;
    const radioName = grid.dataset.optionName + '-' + grid.dataset.optionPosition;
    const target = [...picker.querySelectorAll('input[type="radio"]')].find(
      (input) => input.name.trim() === radioName && input.value === name
    );
    if (target && !target.disabled && !target.checked) target.click();
  }

  function setMode(root, mode) {
    const tabs = [...root.querySelectorAll('[data-rf-v4-mode-tab]')];
    if (!tabs.some((tab) => tab.dataset.rfV4ModeTab === mode)) {
      mode = 'enquiry';
    }
    root.dataset.rfV4Mode = mode;
    const grid = root.querySelector('[data-rf-v4-grid]');
    if (grid) grid.dataset.rfV4Mode = mode;
    tabs.forEach((tab) => {
      const active = tab.dataset.rfV4ModeTab === mode;
      tab.setAttribute('aria-pressed', String(active));
    });
    root.querySelectorAll('[data-rf-v4-panel]').forEach((panel) => {
      const panelMode = panel.dataset.rfV4Panel;
      panel.hidden = panelMode !== mode;
    });
    summary(root);
  }


  function setHeaderOffset(root) {
    if (window.innerWidth <= 950) return;
    const header = document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
    const height = header?.getBoundingClientRect()?.height || 70;
    root.style.setProperty('--rf-v4-header-bottom', Math.max(80, Math.ceil(height) + 12) + 'px');
  }

  function setup(root) {
    if (root.dataset.rfV4GridReady) return;
    root.dataset.rfV4GridReady = '1';
    setHeaderOffset(root);
    window.addEventListener('resize', () => setHeaderOffset(root), { passive: true });

    setMode(root, 'enquiry');
    syncEnquiryForm(root);
  }

  document.addEventListener('click', (event) => {
    const modeTab = event.target.closest('[data-rf-v4-mode-tab]');
    if (modeTab) {
      const root = rootOf(modeTab);
      if (root) setMode(root, modeTab.dataset.rfV4ModeTab);
      return;
    }
    const imageButton = event.target.closest('[data-rf-v4-preview], [data-rf-v4-cover]');
    if (!imageButton) return;
    const root = rootOf(imageButton);
    if (!root || imageButton.disabled) return;
    const name = imageButton.dataset.colour || '';
    preview(root, name, imageButton.dataset.imageMain);
    if (!name) return;
    const card = findCard(root, name);
    // Photos only preview; they do not toggle enquiry checkboxes or choose Shopify variants.
    if (window.matchMedia('(max-width:950px)').matches && card) {
      const expanded = card.classList.contains('is-expanded');
      cardsOf(root).forEach((item) => item.classList.remove('is-expanded'));
      if (!expanded) card.classList.add('is-expanded');
    }
  });

  document.addEventListener('change', (event) => {
    const element = event.target;
    const root = rootOf(element);
    if (!root) return;
    if (element.matches('[data-rf-v4-enquire-colour]')) {
      syncEnquiryForm(root);
    } else if (element.matches('[data-rf-v4-purchase-colour]')) {
      if (!element.checked) return;
      const card = findCard(root, element.value);
      preview(root, element.value, card?.querySelector('[data-rf-v4-preview]')?.dataset.imageMain);
      selectVariant(root, element.value);
      summary(root);
    } else if (element.matches('[data-rf-enquiry-colour-choice]')) {
      // Legacy enquiry form wiring remains available but it is visually hidden in V4.
      summary(root);
    } else if (element.matches('variant-selects input[type="radio"]')) {
      const grid = root.querySelector('[data-rf-v4-grid]');
      if (!grid || element.name.trim() !== grid.dataset.optionName + '-' + grid.dataset.optionPosition) return;
      purchaseOf(root).forEach((input) => { input.checked = input.value === element.value; });
      const card = findCard(root, element.value);
      preview(root, element.value, card?.querySelector('[data-rf-v4-preview]')?.dataset.imageMain);
      summary(root);
    }
  });

  const init = (scope = document) => {
    if (scope.matches?.('product-info.rf-floorboards-v4')) setup(scope);
    scope.querySelectorAll?.('product-info.rf-floorboards-v4').forEach(setup);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
